import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/loading.js");
